import * as generalAPI from '../../../general/api';

export function getTestCases(params) {
  return generalAPI.getTestCases({ cloudType: 'vdc', ...params });
}

export function getTestCasesCSV({ queryParams }) {
  return generalAPI.getTestCasesCSV({ cloudType: 'vdc', queryParams });
}

export function getTestCasesTrends(params) {
  return generalAPI.getTestCasesTrends({ cloudType: 'vdc', ...params });
}
